import React, { useState } from "react";
import "../gameTutorial/styles.css";
import { GameTutorialElements } from "./types";
import { useIntl } from "react-intl";
import { isDesktop } from "react-device-detect";

// this array contains all the existing feature available
// but not necessary all used by the organization as of 21/12/20022 and may
// change in the futur. if so please update the array as the date above.
const features = [
	`.${GameTutorialElements.FILE_BUTTON}`,
	`.${GameTutorialElements.EMAIL_BUTTON}`,
	`.${GameTutorialElements.EMAIL_BUTTON}`,
	`.${GameTutorialElements.CHAT_BUTTON}`,
	`.${GameTutorialElements.NOTE_BUTTON}`,
	`.${GameTutorialElements.BROWSER_BUTTON}`,
	`.${GameTutorialElements.HELP_BUTTON}`,
];

const useGameTutorial = (stepRef, organization, botName, playinTimeInMillis?) => {
	const intl = useIntl();
	const [isLoaded, setIsLoaded] = useState(false);
	const [steps, setSteps] = useState([
		{
			element: `.${GameTutorialElements.INTRO_MODAL}`,
			intro: intl.formatMessage(
				{ id: "TUTORIAL.message.intro" },
				{ organization: organization, tag1: "<strong>", tag2: "</strong>", tag3: "</br>" },
			),
			category: "intro",
		},
		{
			element: `.${GameTutorialElements.FILE_BUTTON}`,
			intro: intl.formatMessage(
				{ id: "TUTORIAL.message.file-button" },
				{ tag1: "<strong>", tag2: "</strong>", tag3: "</br>" },
			),

			category: "files",
		},
		{
			element: `.${GameTutorialElements.FILE_BROWSER_WINDOW}`,
			intro: intl.formatMessage(
				{ id: "TUTORIAL.message.file-browser-window" },
				{ tag1: "<strong>", tag2: "</strong>", tag3: "</br>" },
			),
			category: "files",
			position: "right",
		},
		{
			element: `.${GameTutorialElements.FILE_TILE}`,
			intro: intl.formatMessage(
				{ id: "TUTORIAL.message.file-tile" },
				{ tag1: "<strong>", tag2: "</strong>", tag3: "</br>" },
			),
			category: "files",
			position: "right",
		},
		{
			element: `.${GameTutorialElements.EMAIL_BUTTON}`,
			intro: intl.formatMessage(
				{ id: "TUTORIAL.message.email-button" },
				{ tag1: "<strong>", tag2: "</strong>", tag3: "</br>" },
			),
			category: "emails",
		},
		{
			element: `.${GameTutorialElements.EMAIL_BROWSER_WINDOW}`,
			intro: intl.formatMessage(
				{ id: "TUTORIAL.message.email.browser-window" },
				{ tag1: "<strong>", tag2: "</strong>", tag3: "</br>" },
			),
			position: "right",
			category: "emails",
		},
		{
			element: `.${GameTutorialElements.CHAT_BUTTON}`,
			intro: intl.formatMessage(
				{ id: "TUTORIAL.message.chat-button" },
				{ botName: botName, tag1: "<strong>", tag2: "</strong>", tag3: "</br>" },
			),
			category: "chat",
		},
		{
			element: `.${GameTutorialElements.CHAT_BROWSER_WINDOW}`,
			intro: intl.formatMessage(
				{ id: "TUTORIAL.message.chat-browser-window" },
				{ tag1: "<strong>", tag2: "</strong>", tag3: "</br>" },
			),
			position: "right",
			category: "chat",
		},
		{
			element: `.${GameTutorialElements.NOTE_BUTTON}`,
			intro: intl.formatMessage(
				{ id: "TUTORIAL.message.note-button" },
				{ tag1: "<strong>", tag2: "</strong>", tag3: "</br>" },
			),
			category: "notes",
		},
		{
			element: `.${GameTutorialElements.NOTE_BORWSER_WINDOW}`,
			intro: intl.formatMessage(
				{ id: "TUTORIAL.message.note-browser-window" },
				{ tag1: "<strong>", tag2: "</strong>", tag3: "</br>" },
			),
			category: "notes",
			position: "left",
		},
		{
			element: `.${GameTutorialElements.BROWSER_BUTTON}`,
			intro: intl.formatMessage(
				{ id: "TUTORIAL.message.browser.button" },
				{ tag1: "<strong>", tag2: "</strong>", tag3: "</br>" },
			),
			category: "browser",
		},
		{
			element: `.${GameTutorialElements.LOGOUT_BUTTON}`,
			intro: intl.formatMessage(
				{ id: "TUTORIAL.message.logout.button" },
				{ tag1: "<strong>", tag2: "</strong>", tag3: "</br>" },
			),
			category: "logout",
		},
		{
			element: `.${GameTutorialElements.HELP_BUTTON}`,
			intro: intl.formatMessage(
				{ id: "TUTORIAL.message.help-button" },
				{ tag1: "<strong>", tag2: "</strong>", tag3: "</br>" },
			),
			category: "Hulp Knop",
		},
	]);

	const [isTutorialShown, setIsTutorialShown] = useState<boolean>(() => {
		const tutorialLocalStorageKey = "TUTORIAL_Flag";
		// we check if the room is being open for the first time and if there is a local storage TUTORIAL_Flag
		// if this is the case then we remove the local storage item so the tutorial can be displayed.
		if (playinTimeInMillis === 0 && localStorage.getItem(tutorialLocalStorageKey) === "TRUE") {
			localStorage.removeItem(tutorialLocalStorageKey);
		}
		return localStorage.getItem(tutorialLocalStorageKey) === "TRUE";
	});

	React.useEffect(() => {
		let category;
		const arrOfAbsentFeatures = [];
		// for each feature from features we want to know
		// if the class exist in the html.
		// if it doesn't <=> return null; then we filter the step out and
		// its related tutorial by filtering thanks to category value.
		for (let feature of features) {
			if (document.querySelector(feature) === null) {
				category = steps.find((el) => el.element === feature)?.category;
				// @ts-ignore
				category && arrOfAbsentFeatures.push(category);
			}
		}
		arrOfAbsentFeatures.length !== 0 &&
			setSteps((prev) => {
				// @ts-ignore
				return [...prev.filter((el) => !arrOfAbsentFeatures.includes(el.category))];
			});
		setIsLoaded(true);
	}, [steps]);

	const onBeforeChange = (nextStepIndex, u) => {
		if (nextStepIndex === 0) return;

		if (steps[nextStepIndex - 1].element === ".browserButton") return;

		// check if the feature exist. if so open the feature and updateStateElement
		if (features.includes(steps[nextStepIndex - 1].element)) {
			const makeArrayOfClasses = document.querySelector(steps[nextStepIndex - 1].element)?.className.split(" ");
			const classNameIdx = features.findIndex((el) => {
				// @ts-ignore
				return makeArrayOfClasses?.includes(el.substring(1, el.length));
			});
			const el = document.querySelector(features[classNameIdx]) as HTMLElement | null;
			//@ts-ignore
			if (el !== null) el.click();
			stepRef?.current?.updateStepElement(nextStepIndex);
		}
		// check if the nextStep class contain 'Button'.
		// Meaning in the next step we are going to open a different feature.
		// so we need to close the existing one first
		if (steps[nextStepIndex]?.element.includes("Button") || (nextStepIndex === 3 && !isDesktop)) {
			const el = document.querySelector(".closeButton") as HTMLElement | null;
			//@ts-ignore
			if (el !== null) el.click();
		}
	};

	function setTutorialAsDone() {
		localStorage.setItem("TUTORIAL_Flag", "TRUE");
		setIsTutorialShown(true);
	}

	/**
	 * This effect is used to add a click event listener on the skip button
	 * when the tutorial is loaded.
	 * This is necessary because the skip button is not present in the DOM
	 */
	React.useEffect(() => {
		const handleSkipButtonClick = () => {
			setTutorialAsDone();
		};

		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.type === "childList") {
					const skipButton = document.querySelector(".introjs-skipbutton") as HTMLButtonElement;
					if (skipButton) {
						skipButton.addEventListener("click", handleSkipButtonClick);
					}
				}
			});
		});

		if (isLoaded) {
			observer.observe(document.body, { childList: true, subtree: true });
		}

		return () => {
			observer.disconnect();
		};
	}, [isLoaded]);

	/**
	 * Exit callback triggered when:
	 * 1. the user click on the skip button
	 * 2. the Steps component unmounted
	 * 3. the user completed the tutorial until the last step
	 * @param stepIndex
	 */
	function exit(stepIndex: number) {
		const el = document.querySelector(".closeButton") as HTMLElement | null;
		//@ts-ignore
		if (el !== null) el.click();

		/**
		 * set tutorial as done if the user completed the tutorial
		 * also to prevent the tutorial marked as done when the leave the page or logout
		 */
		if (stepIndex === steps.length - 1) {
			setTutorialAsDone();
		}
	}

	return { onBeforeChange, exit, steps, enabled: !isTutorialShown, isLoaded };
};

export default useGameTutorial;
